/* ============================================================
   JACKET theme engine — Shopify AJAX Cart API
   Ported from the static demo: same UI, real cart.
   ============================================================ */
(function () {
  "use strict";

  var SETTINGS = window.jacketSettings || {};
  var THRESHOLD_CENTS = (SETTINGS.freeShippingThreshold || 50) * 100;

  function money(cents) {
    return "$" + (cents / 100).toFixed(2);
  }

  /* ---------- cart API ---------- */
  function getCart() {
    return fetch("/cart.js", { credentials: "same-origin" }).then(function (r) { return r.json(); });
  }

  function addToCart(variantId, qty, sellingPlanId) {
    var body = { id: Number(variantId), quantity: qty || 1 };
    if (sellingPlanId) body.selling_plan = Number(sellingPlanId);
    return fetch("/cart/add.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return r.json();
    }).then(function (line) {
      if (window.oaiq) {
        window.oaiq("measure", "items_added", {
          type: "contents",
          amount: line.final_line_price,
          currency: "USD",
          contents: [{ id: line.variant_id, quantity: line.quantity, amount: line.final_price }],
        });
      }
      return line;
    });
  }

  function changeLine(key, qty) {
    return fetch("/cart/change.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: qty }),
    }).then(function (r) { return r.json(); });
  }

  function updateCounts(cart) {
    document.querySelectorAll(".cart-count").forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
  }

  /* ---------- mini-cart drawer ---------- */
  var drawer = document.getElementById("cart-drawer");
  var lastFocus = null;

  function titleCase(t) {
    return (t || "").toLowerCase().replace(/(^|[\s\-(])[a-z]/g, function (c) { return c.toUpperCase(); })
      .replace(/\bSpf\b/g, "SPF").replace(/\bUva\b/g, "UVA").replace(/\bUvb\b/g, "UVB").replace(/\bUpf\b/g, "UPF");
  }

  function addonData() {
    var el = document.getElementById("cd-addon-data");
    if (!el) return [];
    try { return JSON.parse(el.textContent) || []; } catch (e) { return []; }
  }

  function renderDrawer(cart, addedKey) {
    if (!drawer) return;
    var items = document.getElementById("cd-items");
    items.innerHTML = cart.items
      .map(function (l) {
        return (
          '<div class="cd-line' + (addedKey && l.key === addedKey ? " is-new" : "") + '">' +
          '<div class="cdl-media">' + (l.image ? '<img src="' + l.image + '&width=200" alt="" />' : "") + "</div>" +
          '<div class="cdl-info">' +
          '<div class="cdl-title">' + l.product_title + "</div>" +
          (l.selling_plan_allocation && l.selling_plan_allocation.selling_plan
            ? '<div class="cdl-opt">' + l.selling_plan_allocation.selling_plan.name + "</div>"
            : l.variant_title ? '<div class="cdl-opt">' + l.variant_title + "</div>" : "") +
          '<div class="qty-mini cdl-qty">' +
          '<button type="button" data-cd-dec="' + l.key + '" aria-label="Decrease quantity">&minus;</button>' +
          "<span>" + l.quantity + "</span>" +
          '<button type="button" data-cd-inc="' + l.key + '" aria-label="Increase quantity">+</button>' +
          "</div></div>" +
          '<div class="cdl-right">' +
          '<div class="cdl-price">' + money(l.final_line_price) + "</div>" +
          '<button class="cdl-remove" type="button" data-cd-remove="' + l.key + '">Remove</button>' +
          "</div></div>"
        );
      })
      .join("");

    var remaining = Math.max(0, THRESHOLD_CENTS - cart.total_price);
    var ship = document.getElementById("cd-ship");
    if (ship) {
      if (cart.total_price >= THRESHOLD_CENTS && cart.item_count > 0) {
        ship.classList.add("won");
        ship.innerHTML =
          '<span class="won-burst">&#10042;</span>' +
          '<span class="won-text"><b>Free shipping unlocked!</b><span class="won-sub">Nice &mdash; it\'s on us.</span></span>' +
          '<span class="won-confetti" aria-hidden="true"><i></i><i></i><i></i><i></i><i></i><i></i></span>';
      } else {
        ship.classList.remove("won");
        ship.innerHTML = "You're <b>" + money(remaining) + "</b> away from free shipping";
      }
    }

    var addonsWrap = document.getElementById("cd-addons");
    if (addonsWrap) {
      var inCart = {};
      cart.items.forEach(function (l) { inCart[l.product_id] = true; });
      var picks = [];
      if (remaining > 0) {
        picks = addonData().filter(function (p) { return p.available && !inCart[p.id]; });
        // rank: cheapest item that single-handedly crosses the threshold first;
        // otherwise the one that gets closest (largest price under the gap)
        picks.sort(function (a, b) {
          var ac = a.price >= remaining ? 0 : 1;
          var bc = b.price >= remaining ? 0 : 1;
          if (ac !== bc) return ac - bc;
          if (ac === 0) return a.price - b.price;
          return b.price - a.price;
        });
        picks = picks.slice(0, 2);
      }
      if (picks.length) {
        addonsWrap.innerHTML =
          '<div class="cd-addons-title">&#10042; Complete your routine</div>' +
          '<div class="cd-addons-grid">' +
          picks
            .map(function (p) {
              return (
                '<button class="cd-addon" type="button" data-addon-variant="' + p.variantId + '">' +
                '<div class="cd-addon-media"><img src="' + p.image + '" alt="" /></div>' +
                '<div class="cd-addon-info"><div class="n">' + titleCase(p.title) + '</div><div class="p">' + money(p.price) + "</div></div>" +
                '<span class="cd-addon-add">Add +</span></button>'
              );
            })
            .join("") +
          "</div>";
        addonsWrap.hidden = false;
      } else {
        addonsWrap.hidden = true;
        addonsWrap.innerHTML = "";
      }
    }

    var sub = document.getElementById("cd-subtotal-val");
    if (sub) sub.textContent = money(cart.total_price);
    var count = document.getElementById("cd-count");
    if (count) count.textContent = cart.item_count;
    updateCounts(cart);
  }

  function openDrawer(addedKey) {
    if (!drawer) return;
    getCart().then(function (cart) {
      renderDrawer(cart, addedKey);
      var wasHidden = drawer.hidden;
      drawer.hidden = false;
      requestAnimationFrame(function () { drawer.classList.add("open"); });
      document.body.style.overflow = "hidden";
      if (wasHidden) {
        lastFocus = document.activeElement;
        requestAnimationFrame(function () {
          var c = document.getElementById("cd-close");
          if (c) c.focus();
        });
      }
    });
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove("open");
    document.body.style.overflow = "";
    if (lastFocus) { try { lastFocus.focus(); } catch (e) {} lastFocus = null; }
    setTimeout(function () { drawer.hidden = true; }, 340);
  }

  if (drawer) {
    drawer.addEventListener("click", function (e) {
      if (e.target === drawer) closeDrawer();
      var addBtn = e.target.closest("[data-addon-variant]");
      if (addBtn) {
        addToCart(addBtn.dataset.addonVariant, 1).then(function (line) { openDrawer(line.key); });
        return;
      }
      var inc = e.target.closest("[data-cd-inc]");
      var dec = e.target.closest("[data-cd-dec]");
      var rem = e.target.closest("[data-cd-remove]");
      if (inc || dec || rem) {
        var key = (inc || dec || rem).getAttribute(inc ? "data-cd-inc" : dec ? "data-cd-dec" : "data-cd-remove");
        getCart().then(function (cart) {
          var line = cart.items.filter(function (l) { return l.key === key; })[0];
          var q = rem ? 0 : line ? line.quantity + (inc ? 1 : -1) : 0;
          changeLine(key, Math.max(0, q)).then(function (updated) {
            if (updated.item_count === 0) { closeDrawer(); updateCounts(updated); }
            else renderDrawer(updated);
          });
        });
      }
    });
    var closeBtn = document.getElementById("cd-close");
    if (closeBtn) closeBtn.addEventListener("click", closeDrawer);
    var contBtn = document.getElementById("cd-continue");
    if (contBtn) contBtn.addEventListener("click", closeDrawer);

    // swipe-down-to-dismiss
    (function () {
      var sheet = drawer.querySelector(".cart-drawer");
      var head = drawer.querySelector(".cd-head");
      var dragging = false, startY = 0, dy = 0;
      if (!sheet) return;
      sheet.addEventListener("pointerdown", function (e) {
        var ok = e.target === sheet || (head && head.contains(e.target) && !e.target.closest("#cd-close"));
        if (!ok) return;
        dragging = true; startY = e.clientY; dy = 0;
        sheet.style.transition = "none";
        try { sheet.setPointerCapture(e.pointerId); } catch (err) {}
      });
      sheet.addEventListener("pointermove", function (e) {
        if (!dragging) return;
        dy = Math.max(0, e.clientY - startY);
        sheet.style.transform = "translateY(" + dy + "px)";
      });
      function end() {
        if (!dragging) return;
        dragging = false;
        sheet.style.transition = "";
        sheet.style.transform = "";
        if (dy > 110) closeDrawer();
      }
      sheet.addEventListener("pointerup", end);
      sheet.addEventListener("pointercancel", end);
    })();
  }

  /* ---------- global add-to-cart buttons (cards) ---------- */
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-add-variant]");
    if (!btn) return;
    e.preventDefault();
    addToCart(btn.dataset.addVariant, 1).then(function (line) {
      var txt = btn.querySelector(".txt");
      btn.classList.add("added");
      if (txt) txt.textContent = "Added ✓";
      setTimeout(function () {
        btn.classList.remove("added");
        if (txt) txt.textContent = "Add +";
      }, 1100);
      openDrawer(line.key);
    }).catch(function () {});
  });

  /* ---------- PDP ---------- */
  var pdp = document.getElementById("pdp-media");
  if (pdp) {
    // Keep the merged-page rating visible while Shopify refreshes cached section HTML.
    if (window.location.pathname === "/products/spf-50-anti-aging-sunscreen") {
      var ratingBadge = document.querySelector(".pdp-review-badge");
      if (ratingBadge && !ratingBadge.querySelector(".pdp-combined-rating")) {
        ratingBadge.innerHTML = '<div class="jdgm-prev-badge pdp-combined-rating" data-average-rating="4.9" data-number-of-reviews="473" data-number-of-questions="0"><span class="jdgm-prev-badge__stars" data-score="4.9" tabindex="0" aria-label="4.9 stars" role="button"><span class="jdgm-star jdgm--on"></span><span class="jdgm-star jdgm--on"></span><span class="jdgm-star jdgm--on"></span><span class="jdgm-star jdgm--on"></span><span class="jdgm-star jdgm--on"></span></span> <span class="jdgm-prev-badge__text">473 ratings</span></div>';
      }
    }

    var qty = 1;
    var qtyVal = document.getElementById("qty-val");
    var dec = document.getElementById("qty-dec");
    var inc = document.getElementById("qty-inc");
    if (dec) dec.addEventListener("click", function () { qty = Math.max(1, qty - 1); qtyVal.textContent = qty; });
    if (inc) inc.addEventListener("click", function () { qty += 1; qtyVal.textContent = qty; });

    // gallery
    var thumbs = document.getElementById("pdp-thumbs");
    var mainImg = document.getElementById("pdp-img");
    if (thumbs) {
      thumbs.addEventListener("click", function (e) {
        var b = e.target.closest(".pdp-thumb");
        if (!b) return;
        mainImg.src = b.dataset.full;
        var isPhoto = b.dataset.type === "photo";
        pdp.classList.toggle("is-photo", isPhoto);
        pdp.style.setProperty("--bg-photo", isPhoto ? 'url("' + b.dataset.full + '")' : "none");
        thumbs.querySelectorAll(".pdp-thumb").forEach(function (t) { t.classList.toggle("active", t === b); });
      });
    }

    // variant options
    var currentVariant = null;
    document.querySelectorAll(".option[data-variant]").forEach(function (opt) {
      if (opt.classList.contains("selected")) currentVariant = opt.dataset.variant;
      opt.addEventListener("click", function () {
        currentVariant = opt.dataset.variant;
        document.querySelectorAll(".option[data-variant]").forEach(function (o) {
          var sel = o === opt;
          o.classList.toggle("selected", sel);
          o.setAttribute("aria-checked", String(sel));
        });
        var price = document.getElementById("pdp-price");
        if (price) price.textContent = opt.dataset.price;
        var addBtn = document.getElementById("add-to-cart");
        if (addBtn) addBtn.dataset.variant = currentVariant;
        var sticky = document.getElementById("sticky-add");
        if (sticky) sticky.dataset.variant = currentVariant;
      });
    });

    // purchase options (one-time vs subscription selling plans)
    var purchaseOptions = document.getElementById("purchase-options");
    var currentSellingPlan = "";
    document.querySelectorAll("#purchase-options .option").forEach(function (opt) {
      opt.addEventListener("click", function () {
        currentSellingPlan = opt.dataset.sellingPlan || "";
        document.querySelectorAll("#purchase-options .option").forEach(function (o) {
          var sel = o === opt;
          o.classList.toggle("selected", sel);
          o.setAttribute("aria-checked", String(sel));
        });
        var price = document.getElementById("pdp-price");
        if (price) price.textContent = opt.dataset.price;
        var bb = document.querySelector(".bb-price");
        if (bb) bb.textContent = opt.dataset.price;
      });
    });

    var oneTimeDiscountCode = purchaseOptions ? purchaseOptions.dataset.oneTimeDiscountCode : "";
    var oneTimeDiscountClaimed = false;
    function claimOneTimeDiscount() {
      if (!oneTimeDiscountCode || currentSellingPlan || oneTimeDiscountClaimed) return Promise.resolve();
      oneTimeDiscountClaimed = true;
      return fetch("/discount/" + encodeURIComponent(oneTimeDiscountCode), { credentials: "same-origin" })
        .catch(function () { oneTimeDiscountClaimed = false; });
    }

    function pdpAdd(btn) {
      claimOneTimeDiscount().then(function () {
        return addToCart(btn.dataset.variant, qty, currentSellingPlan);
      }).then(function (line) {
        openDrawer(line.key);
      }).catch(function (err) {
        btn.textContent = (err && err.description) || "Unavailable";
        setTimeout(function () { btn.textContent = "Add to bag"; }, 1800);
      });
    }
    var addBtn = document.getElementById("add-to-cart");
    if (addBtn) addBtn.addEventListener("click", function () { pdpAdd(addBtn); });
    var stickyAdd = document.getElementById("sticky-add");
    if (stickyAdd) stickyAdd.addEventListener("click", function () { pdpAdd(stickyAdd); });

    var buyNow = document.getElementById("buy-now");
    if (buyNow) {
      buyNow.addEventListener("click", function () {
        var v = (document.getElementById("add-to-cart") || {}).dataset.variant;
        if (!v) return;
        var url = "/cart/" + v + ":" + qty;
        if (currentSellingPlan) url += "?selling_plan=" + currentSellingPlan;
        claimOneTimeDiscount().then(function () { window.location.href = url; });
      });
    }

    // sticky buybar: show when inline add-to-cart is off screen
    var buybar = document.getElementById("buybar");
    if (buybar && addBtn && "IntersectionObserver" in window) {
      buybar.hidden = false;
      buybar.classList.add("tucked");
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (en) { buybar.classList.toggle("tucked", en.isIntersecting); });
        },
        { rootMargin: "0px 0px -72px 0px", threshold: 0 }
      );
      io.observe(addBtn);
    }
  }

  /* ---------- collection filters (client-side, by product type) ---------- */
  var filtersEl = document.getElementById("collection-filters");
  var grid = document.getElementById("product-grid");
  if (filtersEl && grid) {
    var items = Array.prototype.slice.call(grid.querySelectorAll(".pg-item"));
    var types = [];
    items.forEach(function (el) {
      var t = el.dataset.type || "Other";
      if (types.indexOf(t) === -1) types.push(t);
    });
    // Chip order: preferred sequence first, anything unexpected after, "Other" last
    var preferred = ["Sunscreen", "SPF Tinted Moisturizer", "Skincare", "Bundles", "Hats", "Shirts"];
    types.sort(function (a, b) {
      var pa = preferred.indexOf(a), pb = preferred.indexOf(b);
      if (a === "Other") return 1;
      if (b === "Other") return -1;
      if (pa === -1 && pb === -1) return 0;
      if (pa === -1) return 1;
      if (pb === -1) return -1;
      return pa - pb;
    });
    if (types.length > 1) {
      var active = "All";
      function renderChips() {
        filtersEl.innerHTML = ["All"].concat(types)
          .map(function (t) {
            return '<button class="filter-chip' + (t === active ? " active" : "") + '" type="button" data-filter="' + t + '">' + t + "</button>";
          })
          .join("");
      }
      renderChips();
      filtersEl.addEventListener("click", function (e) {
        var chip = e.target.closest("[data-filter]");
        if (!chip) return;
        active = chip.dataset.filter;
        renderChips();
        var shown = 0;
        items.forEach(function (el) {
          var t = el.dataset.type || "Other";
          var show = active === "All" || t === active;
          el.style.display = show ? "" : "none";
          if (show) shown++;
        });
        var count = document.getElementById("collection-count");
        if (count) count.textContent = shown + (shown === 1 ? " product" : " products");
        var empty = document.getElementById("collection-empty");
        if (empty) empty.hidden = shown > 0;
      });
    }
  }

  /* ---------- mobile menu ---------- */
  var mm = document.getElementById("mobile-menu");
  var menuBtn = document.getElementById("menu-btn");
  if (mm && menuBtn) {
    function openMenu() {
      mm.hidden = false;
      requestAnimationFrame(function () { mm.classList.add("open"); });
      document.body.style.overflow = "hidden";
      menuBtn.setAttribute("aria-expanded", "true");
      var c = document.getElementById("mm-close");
      if (c) c.focus();
    }
    function closeMenu() {
      mm.classList.remove("open");
      document.body.style.overflow = "";
      menuBtn.setAttribute("aria-expanded", "false");
      menuBtn.focus();
      setTimeout(function () { mm.hidden = true; }, 300);
    }
    menuBtn.addEventListener("click", openMenu);
    var mmClose = document.getElementById("mm-close");
    if (mmClose) mmClose.addEventListener("click", closeMenu);
    mm.addEventListener("click", function (e) { if (e.target === mm) closeMenu(); });
    mm.querySelectorAll(".mm-nav a").forEach(function (a) { a.addEventListener("click", closeMenu); });
  }

  /* ---------- derm modal ---------- */
  var dermModal = document.getElementById("derm-modal");
  if (dermModal) {
    function openDerm() {
      lastFocus = document.activeElement;
      dermModal.hidden = false;
      requestAnimationFrame(function () {
        dermModal.classList.add("open");
        var c = document.getElementById("derm-close");
        if (c) c.focus();
      });
      document.body.style.overflow = "hidden";
    }
    function closeDerm() {
      dermModal.classList.remove("open");
      document.body.style.overflow = "";
      if (lastFocus) { try { lastFocus.focus(); } catch (e) {} lastFocus = null; }
      setTimeout(function () { dermModal.hidden = true; }, 260);
    }
    document.addEventListener("click", function (e) {
      if (e.target.closest("[data-derm]")) openDerm();
    });
    dermModal.addEventListener("click", function (e) { if (e.target === dermModal) closeDerm(); });
    var dc = document.getElementById("derm-close");
    if (dc) dc.addEventListener("click", closeDerm);
    var dok = document.getElementById("derm-ok");
    if (dok) dok.addEventListener("click", closeDerm);
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !dermModal.hidden) closeDerm();
    });
  }

  /* ---------- Esc + focus trap for overlays ---------- */
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && drawer && !drawer.hidden) closeDrawer();
    if (e.key !== "Tab") return;
    var open = document.querySelector("#derm-modal.open, #cart-drawer.open, #mobile-menu.open");
    if (!open) return;
    var f = Array.prototype.filter.call(
      open.querySelectorAll('a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])'),
      function (el) { return el.offsetParent !== null; }
    );
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* ---------- scroll reveals ---------- */
  if ("IntersectionObserver" in window) {
    var revealObs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            en.target.classList.add("in");
            revealObs.unobserve(en.target);
          }
        });
      },
      { rootMargin: "0px 0px -8% 0px", threshold: 0.08 }
    );
    document.querySelectorAll("[data-reveal]").forEach(function (el) { revealObs.observe(el); });
  } else {
    document.querySelectorAll("[data-reveal]").forEach(function (el) { el.classList.add("in"); });
  }

  /* ---------- park infinite animations while offscreen ---------- */
  if ("IntersectionObserver" in window) {
    var animObs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (en) {
          en.target.classList.toggle("anim-off", !en.isIntersecting);
        });
      },
      { rootMargin: "80px 0px 80px 0px" }
    );
    document.querySelectorAll(".announcement, .solar-strip, .hero").forEach(function (el) {
      animObs.observe(el);
    });
  }
})();
